import TemporaryPreview from '@/pages/public/TemporaryPreview'

export default [
    {
        path: '/file-preview/:uuid',
        name: 'TemporaryPreview',
        component: TemporaryPreview,
        meta: {
            title: 'Findus | Digital Archive - Preview'
        }
    },
];



// WEBPACK FOOTER //
// ./src/router/modules/public.js